module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav",
    class: {
      open: _vm.isClicked
    }
  }, [_c('div', {
    staticClass: "nav__open-bg",
    class: {
      open: _vm.isClicked
    },
    on: {
      "click": _vm.toggle2
    }
  }), _c('div', {
    staticClass: "nav__bg"
  }, [_c('div', {
    staticClass: "nav__container",
    class: {
      open: _vm.isClicked
    }
  }, [_c('div', {
    staticClass: "nav__logo",
    class: {
      scrolled: this.$store.state.nav, open: _vm.isClicked
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "logo"
    }
  })], 1)], 1), _c('div', {
    staticClass: "nav__link-container",
    class: {
      scrolled: this.$store.state.nav, open: _vm.isClicked
    }
  }, [_c('div', {
    staticClass: "nav__hamburger",
    on: {
      "click": _vm.toggle
    }
  }, [_c('span'), _c('span'), _c('span'), _c('span')]), _c('div', {
    staticClass: "nav__outer-link-1",
    class: {
      open: _vm.isClicked
    }
  }, [_c('a', {
    attrs: {
      "id": "phonenew",
      "href": "tel:+15168683131",
      "onclick": "gtag('send', 'event', 'Phone Call Tracking', 'Sticky Click to Call', '(516)868-3131', 0);"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "phone"
    }
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("516-868-3131")])], 1)])]), _c('div', {
    staticClass: "nav__links",
    class: {
      open: _vm.isClicked
    }
  }, [_c('div', {
    staticClass: "nav__links-container"
  }, [_vm._l((_vm.links), function(link) {
    return _c('div', {
      staticClass: "nav__link",
      on: {
        "click": _vm.toggle3
      }
    }, [(link.name !== "redirect" && link.name !== "AccessibilityStatement" && link.name !== "ThankYou") ? _c('router-link', {
      attrs: {
        "to": link.path
      }
    }, [_vm._v(_vm._s(link.name))]) : _vm._e()], 1)
  }), _c('div', {
    staticClass: "nav__special"
  }, [_c('div', {
    staticClass: "nav__icon-links"
  }, [_c('div', {
    staticClass: "nav__icon-1"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/Sukoff-Orthodontics-168483843167430/"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "fb-icon"
    }
  })], 1)]), _c('div', {
    staticClass: "nav__icon-2"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "instagram"
    }
  })], 1)]), _c('div', {
    staticClass: "nav__icon-3"
  }, [_c('a', {
    attrs: {
      "href": "https://www.google.com/maps/place/David+H.+Sukoff,+DDS,+PC/@40.6650832,-73.5530176,15z/data=!4m5!3m4!1s0x0:0xf5027bec57da3152!8m2!3d40.6650832!4d-73.5530176?sa=X&ved=0ahUKEwichqTLoIjRAhVrslQKHRWgDaoQ_BIIgAEwCg&shorturl=1"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "google-plus"
    }
  })], 1)])]), _vm._m(0), _c('div', {
    staticClass: "nav__link-1"
  }, [_c('router-link', {
    attrs: {
      "to": "/Contact-us"
    }
  }, [_vm._v("Request Appointment")])], 1), _c('div', {
    staticClass: "nav__link-1"
  }, [_c('a', {
    attrs: {
      "href": "tel:+15168683131"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "phone"
    }
  }), _vm._v("516-868-3131")], 1)])])], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav__link-1"
  }, [_c('a', {
    attrs: {
      "href": "https://patient-portal-prd-cluster-3.sesamecommunications.com/sukoffortho/index.html"
    }
  }, [_vm._v("Patient Login")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cf790b6","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/Nav/Nav.pug
// module id = 610
// module chunks = 1